const BussinessIcon = () => {
    return (
        <svg width={30} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
		  <path d="M10.7891 24.352L28.871 17.9576C29.3684 17.7444 29.9012 18.0997 29.9012 18.6326V23.3218C29.9012 23.8547 30.4696 24.2099 30.9315 23.9968L43.969 17.9931C44.4663 17.78 44.9992 18.1352 44.9992 18.6681V37.5671C44.9992 39.4499 43.4716 40.9775 41.5888 40.9775H10.7891V24.352Z" fill="#657FA5" />
		  <path d="M25.3556 34.4763H22.0163C21.5545 34.4763 21.1992 34.1211 21.1992 33.6593V31.1015C21.1992 30.6397 21.5545 30.2844 22.0163 30.2844H25.3556C25.8174 30.2844 26.1726 30.6397 26.1726 31.1015V33.6593C26.1726 34.1211 25.8174 34.4763 25.3556 34.4763Z" fill="#EEECFF" />
		  <path d="M35.088 34.4763H31.7487C31.2869 34.4763 30.9316 34.1211 30.9316 33.6593V31.1015C30.9316 30.6397 31.2869 30.2844 31.7487 30.2844H35.088C35.5498 30.2844 35.9051 30.6397 35.9051 31.1015V33.6593C35.9051 34.1211 35.5143 34.4763 35.088 34.4763Z" fill="#EEECFF" />
		  <path d="M5.2836 10.9947L3.01003 37.6736C2.86793 39.4498 4.25339 40.9774 6.02961 40.9774H12.7437L10.3281 10.9947C10.2926 10.4263 9.79521 10 9.26235 10H6.38486C5.81647 10 5.35465 10.4263 5.2836 10.9947Z" fill="#C4C4C4" />
		</svg>

    )
}

export default BussinessIcon;

